
import { Component, Prop, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import FileUpload from "@common/src/components/scope/file-upload/index.vue";
import { priceRulesEl } from "@common/src/utils/verify";
import t from "@common/src/i18n/t";
import { addCurrencyUnit } from "@common/src/utils/tools";

const purchase = namespace("purchase");

@Component({
  components: { FileUpload }
})
export default class RegisterInvoice extends Vue {
  @purchase.State makeInvoiceBtnLoading;
  @Prop()
  show: boolean;
  @Prop({ default: () => {} })
  paymentData: any;
  addCurrencyUnit = addCurrencyUnit;
  formData: any = {
    invoiceAmount: "",
    invoiceCategoryCode: "",
    invoiceNo: "",
    invoiceUrl: "",
    invoiceType: "2",
    orderNo: ""
  };
  showFlag: boolean = true;
  formDataRules: any = {
    invoiceAmount: [
      {
        required: true,
        message: t("v210831.please-enter-invoicing-amount")
      },
      { validator: this.checkPrice, trigger: "blur" }
    ],
    invoiceCategoryCode: [{ required: true, message: t("service.enter-invoice-code"), trigger: "blur" }],
    invoiceNo: [{ required: true, message: t("service.enter-invoice-number"), trigger: "blur" }]
  };
  handleCancel() {
    this.$emit("update:show", false);
  }
  checkPrice(rule, value, callback) {
    if (!value) {
      callback();
    } else {
      priceRulesEl(value, callback);
    }
  }
  handleOpen() {
    this.formData.invoiceCategoryCode = "";
    this.formData.invoiceNo = "";
    this.formData.invoiceUrl = "";
    this.showFlag = false;
    this.$nextTick(() => {
      this.showFlag = true;
    });
    this.formData.invoiceAmount = this.paymentData.paidAmount || "";
  }
  handleConfirm() {
    (this.$refs.invoiceFormRef as any).validate(valid => {
      if (valid) {
        Object.assign(this.formData, {
          orderNo: this.paymentData.purchaseNo
        });
        this.$emit("confirmBtnClick", Object.assign({}, this.formData));
      }
    });
  }
}
